import type { Make } from 'Types/make';

export const MAKE_SELECTOR_ID = 'makeSelector';
export const MODEL_SELECTOR_ID = 'modelSelector';

export const DEFAULT_MAKE = 0;
export const DEFAULT_MODEL = '';

export const isSelectedOptionDefault = (selectedMake: number, selectedModel: string): boolean =>
	selectedMake === DEFAULT_MAKE || selectedModel === DEFAULT_MODEL;

export const isMakeSelectorDisabled = (makes?: Make[]): boolean => !makes || makes.length === 0;

export const isModelSelectorDisabled = (selectedMake: number): boolean => selectedMake === DEFAULT_MAKE;

export const MOCK_MAKES = [
	{ id: 189, name: 'Abarth', slug: 'abarth' },
	{ id: 154, name: 'Alfa Romeo', slug: 'alfa-romeo' },
	{ id: 155, name: 'Aston Martin', slug: 'aston-martin' },
];

export const MOCK_MODELS = [
	{ id: 1, makeId: 189, name: '124-SPIDER', namePretty: '124 Spider' },
	{ id: 2, makeId: 189, name: 'GOGO', namePretty: 'Gogo' },
	{ id: 3, makeId: 153, name: 'GIULIA', namePretty: 'Giulia' },
];
